// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"dayCruise_checkboxes__B5LwR","element":"dayCruise_element__QgHVA"};